module.exports = __webpack_public_path__ + "img/logoGiro.7ee58e21.svg";